import rolesService from 'services/roles';

export const FETCH_ORGANIZATION_ROLES_REQUEST = 'FETCH_ORGANIZATION_ROLES_REQUEST';
export const FETCH_ORGANIZATION_ROLES_SUCCESS = 'FETCH_ORGANIZATION_ROLES_SUCCESS';
export const FETCH_ORGANIZATION_ROLES_FAILURE = 'FETCH_ORGANIZATION_ROLES_FAILURE';

export const UPDATE_STAFF_SEARCH = 'UPDATE_STAFF_SEARCH';

export const ASSIGN_ROLE_REQUEST = 'ASSIGN_ROLE_REQUEST';
export const ASSIGN_ROLE_SUCCESS = 'ASSIGN_ROLE_SUCCESS';
export const ASSIGN_ROLE_FAILURE = 'ASSIGN_ROLE_FAILURE';

export const REMOVE_ROLE_REQUEST = 'REMOVE_ROLE_REQUEST';
export const REMOVE_ROLE_SUCCESS = 'REMOVE_ROLE_SUCCESS';
export const REMOVE_ROLE_FAILURE = 'REMOVE_ROLE_FAILURE';

export const INVITE_STAFF_REQUEST = 'INVITE_STAFF_REQUEST';
export const INVITE_STAFF_SUCCESS = 'INVITE_STAFF_SUCCESS';
export const INVITE_STAFF_FAILURE = 'INVITE_STAFF_FAILURE';

export const FETCH_PENDING_INVITES_REQUEST = 'FETCH_PENDING_INVITES_REQUEST';
export const FETCH_PENDING_INVITES_SUCCESS = 'FETCH_PENDING_INVITES_SUCCESS';
export const FETCH_PENDING_INVITES_FAILURE = 'FETCH_PENDING_INVITES_FAILURE';

export const CANCEL_INVITE_REQUEST = 'CANCEL_INVITE_REQUEST';
export const CANCEL_INVITE_SUCCESS = 'CANCEL_INVITE_SUCCESS';
export const CANCEL_INVITE_FAILURE = 'CANCEL_INVITE_FAILURE';

export const UPDATE_ORGANIZATION_NAME_REQUEST = 'UPDATE_ORGANIZATION_NAME_REQUEST';
export const UPDATE_ORGANIZATION_NAME_SUCCESS = 'UPDATE_ORGANIZATION_NAME_SUCCESS';
export const UPDATE_ORGANIZATION_NAME_FAILURE = 'UPDATE_ORGANIZATION_NAME_FAILURE';

export const ATTEMPT_UPLOAD_ORGANIZATION_LOGO = 'ATTEMPT_UPLOAD_ORGANIZATION_LOGO';

export const UPLOAD_STAFF_PHOTO_REQUEST = 'UPLOAD_STAFF_PHOTO_REQUEST';
export const UPLOAD_STAFF_PHOTO_SUCCESS = 'UPLOAD_STAFF_PHOTO_SUCCESS';
export const UPLOAD_STAFF_PHOTO_FAILURE = 'UPLOAD_STAFF_PHOTO_FAILURE';

export const CLEAR_STAFF_ERROR = 'CLEAR_STAFF_ERROR';

export function fetchOrganizationRoles(organizationId) {
    return {
        type: FETCH_ORGANIZATION_ROLES_REQUEST,
        payload: { organizationId },
    };
}

export function updateStaffSearch(searchTerm) {
    return {
        type: UPDATE_STAFF_SEARCH,
        payload: { searchTerm },
    };
}

export function assignRole(organizationId, accountId, role, title, bio, photo, name, last_name, instagram, tiktok, facebook, twitter) {
    return {
        type: ASSIGN_ROLE_REQUEST,
        payload: { organizationId, accountId, role, title, bio, photo, name, last_name, instagram, tiktok, facebook, twitter },
    };
}

export function removeRole(organizationId, accountId) {
    return {
        type: REMOVE_ROLE_REQUEST,
        payload: { organizationId, accountId },
    };
}

export function inviteStaff(organizationId, inviteData) {
    return {
        type: INVITE_STAFF_REQUEST,
        payload: { organizationId, inviteData },
    };
}

export function fetchPendingInvites(organizationId) {
    return {
        type: FETCH_PENDING_INVITES_REQUEST,
        payload: { organizationId },
    };
}

export function cancelInvite(organizationId, inviteId) {
    return {
        type: CANCEL_INVITE_REQUEST,
        payload: { organizationId, inviteId },
    };
}

export function updateOrganizationName(organizationId, name) {
    return {
        type: UPDATE_ORGANIZATION_NAME_REQUEST,
        payload: { organizationId, name },
    };
}

export function uploadOrganizationLogo(image) {
    return {
        type: ATTEMPT_UPLOAD_ORGANIZATION_LOGO,
        payload: image,
    };
}

export function uploadStaffPhoto(organizationId, accountId, file) {
    return {
        type: UPLOAD_STAFF_PHOTO_REQUEST,
        payload: { organizationId, accountId, file },
    };
}

export function clearStaffError() {
    return {
        type: CLEAR_STAFF_ERROR,
    };
}

